/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
* */

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import {colors} from "nxtconstants";

const propTypes = {
  content: PropTypes.string,
  setToggled: PropTypes.func.isRequired,
  title: PropTypes.string,
  toggled: PropTypes.bool
};

const defaultProps = {
  title: "",
  content: ""
};

const AccordianItem = ({
  title,
  content,
  toggled,
  setToggled
}) => {
  return (
    <FaqItem className={`${toggled ? "toggled" : ""}`}>
      <FaqItemWrapper
        role="presentation"
        onClick={() => setToggled(!toggled)}
      >
        <FaqTitle>{title}</FaqTitle>
        <CollapseIcon className="collapse-icon" />
      </FaqItemWrapper>
      <FaqDescription className="content">
        <FaqContent>
          {content}
        </FaqContent>
      </FaqDescription>
    </FaqItem>
  );
};

const FaqItem = styled.div`
  border: 1px solid #E9E9E9;
  border-radius: 4px;
  &:not(:last-child) {
    margin-bottom: 4rem;
  }
  &.toggled {
    .collapse-icon::after {
      transform: rotate(180deg);
    }
    .content {
      height: auto;
      max-height: 9999px;
      transition: all 0.5s cubic-bezier(1,0,1,0);
    }
  }

  @media (max-width: 576px) {
    &:not(:last-child) {
      margin-bottom: 1.6rem;
    }
  }
`;

const FaqItemWrapper = styled.div`
  padding: 1.3rem 1.6rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  @media (max-width: 576px) {
    padding: 1.1rem 1.6rem;
    line-height: 1.8;
  }
`;

const FaqTitle = styled.h2`
  font-weight: 400;
  font-weight: 300;
  color: #1C1C1C;
  font-size: inherit;
`;

const CollapseIcon = styled.div`
  height: 20px;
  width: 20px;
  position: relative;

  &::before, &::after {
    content: "";
    position: absolute;
    background-color: ${colors.textGray};
    height: 2px;
    border-radius: 10px;
    width: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    transition: all 0.15s ease-in-out;
  }

  &::after {
    transform: rotate(90deg);
  }

  @media (max-width: 576px) {
    height: 14px;
    width: 14px;
  }
`;

const FaqDescription = styled.div`
  overflow: hidden;
  max-height: 0;
  height: 0;
  border-top: 1px solid #E9E9E9;
  transition: all 0.5s cubic-bezier(0,1,0,1);
`;

const FaqContent = styled.div`
  padding: 1.3rem 4.8rem 2.5rem 3.9rem;
  color: ${colors.textGray};
  line-height: 1.8;

  @media (max-width: 576px) {
    padding: 0 2rem 1rem;
    text-align: justify;
  }
`;

AccordianItem.propTypes = propTypes;
AccordianItem.defaultProps = defaultProps;

export default AccordianItem;
